<h2 mat-dialog-title>{{ ctx.title | translate }}</h2>
<mat-dialog-content>
  @if (ctx.relecture) {
    <p class="text-tw-primary">{{ 'INTERN.WARN_PROD.RELECTURE' | translate }}<strong>{{ ctx.relecture }}</strong></p>
  }
  <p>{{ctx.text | translate }}</p>
  <div class="flex flex-col p-2">
    <p><strong>{{ 'TODO' | translate}} :</strong></p>
    @for (todo of incompleted; track todo) {
      <mat-checkbox (change)="done(todo)">{{ 'INTERN.TODO.'+todo | translate }}</mat-checkbox>
    }
  </div>
  <div class="flex flex-col p-2">
    <p><strong>{{ 'DONE' | translate}} :</strong></p>
    @for (todo of completed; track todo) {
      <mat-checkbox [checked]="true" (change)="undone(todo)">{{ 'INTERN.TODO.'+todo | translate }}</mat-checkbox>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-between">
  <button mat-flat-button mat-dialog-close class="flex-grow bg-tw-disabled">{{ 'CANCEL' | translate }}</button>
  <button mat-flat-button [disabled]="!allDone()" [mat-dialog-close]="true" class="flex-grow bg-tw-primary text-tw-text-light">{{ ctx.valid | translate}}</button>
</mat-dialog-actions>